import {Component, EventEmitter, Injector, OnInit, Output} from '@angular/core';
import {Company} from "../../models/company";
import {Athlete} from "../../models/athlete";
import {NgxSmartModalService} from "ngx-smart-modal";
import {UserService} from "../../services/user/user.service";
import {CategoryService} from "../../services/category/category.service";
import {ServiceService} from "../../services/service/service.service";
import {CompanyService} from "../../services/company/company.service";
import {ActivatedRoute, Router} from "@angular/router";
import Swal from "sweetalert2";
import {BaseComponent} from "../base/base.component";

@Component({
    selector: 'app-company-boarding',
    templateUrl: './company-boarding.component.html',
    styleUrls: ['./company-boarding.component.scss']
})
export class CompanyBoardingComponent extends BaseComponent implements OnInit {

    @Output('step') public stepEmit: EventEmitter<any> = new EventEmitter<any>();

    stepNumber: number = 1;
    steps: any[] = [
        {id: 1, title: 'Infomazioni generali', text: ""},
        {id: 2, title: 'Email', text: ""},
        // {id: 3, title: 'Chiavi Soisy', text: ""},
        {id: 3, title: 'Chiavi Nexi', text: ""},
        {id: 4, title: 'Dati Bonifico', text: ""},
        {id: 5, title: 'Congratulazioni', text: ""},
    ];

    data: any[] = [];
    cities: any[] = [];
    provinces: any[] = [];

    company: Company = new Company();
    companyId: string | undefined;

    legalDocumentFront: File | undefined;
    legalDocumentBack: File | undefined;

    legalDocumentFrontResponse: any;
    legalDocumentBackResponse: any;

    constructor(
        public companyService: CompanyService,
        public router: Router,
        public route: ActivatedRoute,
        private serviceInjector: Injector) {
        super(serviceInjector);
    }

    async ngOnInit(): Promise<void> {

        this.companyId = this.route.snapshot.params['companyId'];

        await this.loadProvinceCities();

        if (this.companyId) this.company = (await this.companyService.getCompanyById(this.companyId)).data;

        console.log('company: ', this.company);

        this.updateCitiesCompany()
    }

    loadProvinceCities() {
        return new Promise((resolve, reject) => {
            fetch('../../../assets/italia_comuni.json')
                .then((jsonData: any) => jsonData.json())
                .then((res: any) => {
                    this.data = res.regioni;
                    this.data.forEach((region: any) => {
                        region.province.forEach((province: any) => this.provinces.push({
                            id: province.code,
                            name: province.nome
                        }))
                    })
                    this.provinces.sort((a: any, b: any) => a.name > b.name ? 1 : -1)

                    resolve(true);
                })
                .catch((error: any) => {
                    console.error('error fetching locationData: ', error)
                    reject(error);
                })
        })
    }

    previousStep() {
        if (this.stepNumber === 1) {
            this.stepNumber = 1;
        }

        this.stepNumber--;
        this.stepEmit.emit(this.stepNumber)

    }

    async nextStep() {

        if (this.stepNumber === 1) {
            this.spinner.show()
            this.legalDocumentFrontResponse = await this.uploadDocument(this.legalDocumentFront!);
            this.legalDocumentBackResponse = await this.uploadDocument(this.legalDocumentBack!);
            this.spinner.hide()

            if ( !this.legalDocumentFrontResponse.success || !this.legalDocumentBackResponse.success ){
                return;
            }

            this.company['legalDocumentFront'] = this.legalDocumentFrontResponse.data;
            this.company['legalDocumentBack'] = this.legalDocumentBackResponse.data;
        }

        let response = await this.companyService.publicUpdateCompany(this.company)
        if (response.success) {
            this.stepNumber++;
            this.stepEmit.emit(this.stepNumber);
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Errore durante il processo, riprovare'
            });
        }
    }

    async boardCompany() {
        await this.companyService.onBoarding(this.companyId!);
        this.stepNumber++;
        this.stepEmit.emit(this.stepNumber);
    }

    updateCitiesCompany() {
        this.cities = [];
        let province: any[] = [];

        this.data.forEach((region: any) => {
            if (region.province.find((province: any) => province.code === this.company.province)) {
                province = region.province.find((province: any) => province.code === this.company.province).comuni
            }
        });

        this.cities = province.map((city: any) => city.nome);

        this.cities.sort();
    }

    backToLogin() {
        this.router.navigate(['/login'])
    }

    chooseDocumentFront(event: any) {
        this.legalDocumentFront = event.target.files[0];
    }

    chooseDocumentBack(event: any) {
        this.legalDocumentBack = event.target.files[0];
    }

    async uploadDocument(file: File) {

        // if (!this.legalDocumentFront || !this.legalDocumentBack) return;

        const formData = new FormData();
        formData.append('file', file)

        this.showSpinner()

        return await this.companyService.uploadCompanyPublic(formData);


    }
}
